import React, { Component } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxIcon from "@material-ui/icons/CheckBoxOutlined";
import { ReactComponent as Star } from "../../PromotionalStoreFront/assets/star.svg";

import { connect } from "react-redux";
import {  getCurrencyIso } from "../../../Helpers/currencyConverter";

export class UseCustomerPoints extends Component {
  render() {
    const {
      language,
      themeColor,
      setUseCustomerPoints,
      useCustomerPoints,
      settings,
      user,
      orderTotal,
      appliedPromo,
    } = this.props;

    const avaialblePoints =
      user?.points - (appliedPromo?.loyalty_points_cost || 0);

    const loyaltyPointsNeeded = Math.ceil(
      orderTotal *
        (settings.loyalty_points_to_money_threshold /
          settings.loyalty_points_to_money_conversion_rate)
    );
    const loyaltyPointsToUse = Math.min(
      Math.floor(avaialblePoints / settings.loyalty_points_to_money_threshold) *
        settings.loyalty_points_to_money_threshold,
      loyaltyPointsNeeded
    );

    const loyaltyPointConvert =
      (
        (loyaltyPointsToUse *
          settings.loyalty_points_to_money_conversion_rate) /
        settings.loyalty_points_to_money_threshold
      ).toFixed(settings.currency_decimals) || "-";
    const currency = getCurrencyIso(settings,language)
    return (
      <div
        style={{
          marginTop: 30,
        }}
      >
        <p
          className="box-title"
          style={{
            textAlign: language === "arabic" ? "right" : "left",
          }}
        >
          {language === "arabic" ? "إستخدام نقاط الولاء" : "Use loyalty Points"}
        </p>
        <div
          className="border-top border-bottom w-100 mx-0 mb-3 py-4"
          style={{
            backgroundColor: "white",
            display: "flex",
            padding: 15,
            justifyContent: "space-between",
            direction: language === "arabic" ? "rtl" : "ltr",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Star
              height={30}
              width={30}
              style={{
                marginRight: language === "arabic" ? 0 : 15,
                marginLeft: language === "arabic" ? 15 : 0,
              }}
            />
            <span
              style={{
                textDecoration:
                  avaialblePoints <
                    settings.loyalty_points_to_money_threshold &&
                  "line-through",
              }}
            >
              {language === "arabic"
                ? "استخدم نقاطك "
                : "Use your loyalty points"}
            </span>
            <span className="mx-2" style={{ fontSize: 12 }}>
              {`(${loyaltyPointsToUse} ${
                language === "arabic" ? "نقطة" : "point"
              } = ${loyaltyPointConvert}
                ${
                (
                  `${
                    currency
                  }`
                )
                })`}
            </span>
          </div>
          <Checkbox
            disabled={
              avaialblePoints < settings.loyalty_points_to_money_threshold ||
              (!settings.enable_wallet_partials &&
                loyaltyPointsNeeded > avaialblePoints)
            }
            checkedIcon={<CheckBoxIcon style={{ color: themeColor }} />}
            checked={useCustomerPoints}
            onChange={(value) =>
              setUseCustomerPoints(
                value.target.checked,
                loyaltyPointsNeeded <= avaialblePoints
              )
            }
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  language: state.store.language,
  themeColor: state.store.store.settings.dark || "#0099cc",
  settings: state.store.store.settings,
  user: state.auth.user,
  appliedPromo: state.cart.promos,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(UseCustomerPoints);
